const HANDOFF_KEY = 'onboarding.spaHandoff';

/**
 * Circuit breaker for the academy -> workeffy onboarding crossing.
 *
 * The academy gate redirects while `meta.onBoardingCompleted !== true`, and the SPA lives in
 * a different document — so `window.location.pathname` can never match the `/w` destination
 * and the usual "already there" self-guard cannot fire. If the SPA fails to write the
 * completion flag, that pair loops forever across full page loads with no way back. Allowing
 * one crossing per session degrades that to "onboarding is skipped" instead of trapping the
 * user.
 */
const readStorage = () => {
  if (typeof window === 'undefined') return null;
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

export const hasHandedOffToOnboardingSpa = () => {
  try {
    return readStorage()?.getItem(HANDOFF_KEY) === '1';
  } catch {
    return false;
  }
};

export const markOnboardingSpaHandoff = () => {
  try {
    readStorage()?.setItem(HANDOFF_KEY, '1');
  } catch {
    // Storage is unavailable (Safari private mode); the crossing still happens.
  }
};

export const clearOnboardingSpaHandoff = () => {
  try {
    readStorage()?.removeItem(HANDOFF_KEY);
  } catch {
    // Nothing to clear.
  }
};
